import { CircularProgress, styled } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { ReactComponent as RoleIcon } from "../../../../svg/adminRoleIcon.svg";
import { ReactComponent as Arrow } from "../../../../svg/arrow.svg";
import { ReactComponent as DeleteIcon } from "../../../../svg/deleteIcon.svg";
import apiCall from "../../../../utils/apiCall";
import SettingsModal from "../SettingsModal/settingsModal";
import EditCertificateScore from "./editScoreSetup";
import DeleteScoreContent from "./deleteScoreContent";
import ViewScoreContent from "./viewScoreContent";
import { ReactComponent as World } from '../../../../svg/world.svg';
import CreateScoreContent from "./createScoreSetupContent";
import { AxiosError } from "axios";

interface ButtonProp {
  handleClick: () => void;
}
interface AllScoreData {
  ScoreId: number;
  Score: number;
  ScoreTypeId: number;
  Description: string;
  ScoreTypeName:string;
}

const ScoreSetup: React.FC<ButtonProp> = ({ handleClick }) => {
    const [name, setName] = useState('');
    const [id, setId] = useState(0);
    const [score, setScore] = useState(0)
    const [scoretype ,setScoreType] = useState(''||0)
    const [scoreTypeName, setScoreTypeName] = useState('');
    const [description, setDescription] = useState('');
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openRoleModal, setOpenRoleModal] = useState(false);
    const [openCard, setOpenCard] = useState(false);
  
    const handleOpenCreateModal = () => setOpenCreateModal(true);
    const handleCloseCreateModal = () => setOpenCreateModal(false);
  
    const handleOpenEditModal = () => setOpenEditModal(true);
    const handleCloseEditModal = () => setOpenEditModal(false);
  
    const handleOpenDeleteModal = () => setOpenDeleteModal(true);
    const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  
    const handleOpenRoleModal = () => setOpenRoleModal(true);
    const handleCloseRoleModal = () => setOpenRoleModal(false);
  
    const handleCard = () => setOpenCard(!openCard);
  
    const handleRole = () => {
      setOpenCard(false);
      handleCloseRoleModal();
    };
  
    const handleDisable = () => {
      handleCloseRoleModal();
      setOpenCard(false);
      handleOpenDeleteModal();
    };
  
    const handleEdit = () => {
      handleCloseRoleModal();
      setOpenCard(false);
      handleOpenEditModal();
    };

    const handleOpen = (setupscore: AllScoreData) => {
      setName(setupscore?.ScoreTypeName);
      setId(setupscore?.ScoreId)
      setScore(setupscore?.Score)
      setScoreType(setupscore?.ScoreTypeId)
      setScoreTypeName(setupscore?.ScoreTypeName)
      setDescription(setupscore?.Description);
      handleOpenRoleModal();
    }
    
  const GetAllScore = async (): Promise<any> => {
    return await apiCall().get(`/SetUp/GetAllScores`);
  };

  const { data, isLoading, isError, error } = useQuery(
    ["get-AllScore"],
    GetAllScore,
    {
      keepPreviousData: true,
      retry: 0,
      enabled: true
    }
  );

  const scoreSetupError = error as AxiosError;
  const scoreSetupErrorMessage = scoreSetupError?.message;

  return (
    <>
    {isLoading ? (
      <CircularProgress 
        sx={{
          fontSize: '1rem',
          marginInline: 'auto',
          display: 'block',
          marginBlock: '2rem'
        }}
      />
    ) : isError ? (
      <StyledError>{scoreSetupErrorMessage}</StyledError>
    ) : (
      <StyledContainer>
        <TotalWrapper>
          <span>Total</span>
          <TotalNumberStyle>{data?.data?.Data.length}</TotalNumberStyle>
        </TotalWrapper>
        {data?.data?.Data &&
        data?.data?.Data.length > 0 &&
        data?.data?.Data.map((data: AllScoreData) => (
          <RoleWrapper onClick={() => handleOpen(data)} key={data.ScoreTypeId}>
            <div>
              <RoleIconWrapper>
                <RoleIcon />
              </RoleIconWrapper>
              <RoleText>{data.ScoreTypeName}</RoleText>
              <Active>{data.Score}</Active>
              <DateWrapper>{data.Description}</DateWrapper>
            </div>
          
            <ArrowIconWrapper>
              <Arrow />
            </ArrowIconWrapper>
          </RoleWrapper>
        ))}

        <SettingsModal
          header={name}
          open={openRoleModal}
          maxWidth={"712px"}
          content={<ViewScoreContent Score={score} description={description} ScoreId={id} ScoreTypeName={scoreTypeName}/>}
          cancel={setOpenRoleModal}
          showrightIcon={true}
          worldIcon={<World/>}
          card={
            <>
              <CardItems onClick={handleEdit}>Update</CardItems>
              <CardItems onClick={handleDisable}>Delete</CardItems>
            </>
          }
        />
        <SettingsModal
          header="Update Score"
          open={openEditModal}
          maxWidth={"480px"}
          content={<EditCertificateScore handleClose={handleCloseEditModal} Score={score} description={description} ScoreId={id} ScoreTypeId={scoretype} />}
          cancel={setOpenEditModal}
          showrightIcon={false}
          worldIcon={<World/>}
        />
   
        <SettingsModal
          header="Delete Score"
          open={openDeleteModal}
          maxWidth={"536px"}
          content={<DeleteScoreContent 
            Score={score} 
            description={name} 
            ScoreId={id} 
            handleClose={handleCloseDeleteModal} 
          />}
          cancel={setOpenDeleteModal}
          showrightIcon={false}
          worldIcon={<DeleteIcon/>}
        />
      </StyledContainer>
    )}
    
    </>
  );
};

export default ScoreSetup;

const StyledContainer = styled("div")`
  margin-block: 3.8rem;
  margin-inline: 3.5rem;
`;

const TotalNumberStyle = styled("span")`
  background-color: #f1f3f4;
  border-radius: 0.2rem;
  margin-inline-start: 0.4rem;
  padding-inline: 0.2rem;
`;

const TotalWrapper = styled("div")`
  color: #4e5a62;
  font-weight: 500;
`;

const RoleWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  border: 0.1rem solid #e1e1e1;
  margin-block: 0.6rem;
  padding-inline: 1.2rem;
  padding-block: 1.2rem;
  border-radius: 0.5rem;
  width: 100%;
  text-align: left;
  background-color: transparent;
`;

const RoleIconWrapper = styled("span")`
  background-color: #fff4de;
  border-radius: 0.1rem;
  padding-inline: 0.4rem;
`;

const RoleText = styled("span")`
  font-weight: 600;
  font-size: 16px;
  margin-inline: 0.8rem;
`;

const Active = styled("span")`
  font-size: 14px;
  font-weight: 500;
  background-color: #e0faee;
  border-radius: 0.4rem;
  padding-inline: 0.5rem;
  color: #11643c;
`;

const DateWrapper = styled("div")`
  margin-block-start: 0.8rem;
  font-size: 14px;
`;

const ArrowIconWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const CardItems = styled(`div`)`
  height: 41px;
  background: #FFFFFF;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-inline-start: 23px;

  &:hover {
    background: #F1F1F1;
  }

`

const StyledError = styled('p')`
  color: red;
  font-size: 1.4rem;
  display: flex;
`